class PriceRangeSlider {
  constructor(
    minInputId,
    maxInputId,
    minValueId,
    maxValueId,
    rangeClass,
    formId
  ) {
    this.minInput = document.getElementById(minInputId);
    this.maxInput = document.getElementById(maxInputId);
    this.minValue = document.getElementById(minValueId);
    this.maxValue = document.getElementById(maxValueId);
    this.range = document.querySelector(`.${rangeClass}`);
    this.form = document.getElementById(formId);

    if (this.minInput && this.maxInput && this.range) {
      this.setInitialValues();
      this.init();
    }
  }

  parseFormattedNumber(value) {
    if (!value) return 0;
    return parseInt(value.replace(/\./g, ''));
  }

  setInitialValues() {
    const urlParams = new URLSearchParams(window.location.search);
    const minValue = urlParams.get("filter.v.price.gte");
    const maxValue = urlParams.get("filter.v.price.lte");

    if (minValue) {
      const parsedMinValue = this.parseFormattedNumber(minValue);
      this.minInput.value = parsedMinValue;
    }

    if (maxValue) {
      const parsedMaxValue = this.parseFormattedNumber(maxValue);
      this.maxInput.value = parsedMaxValue;
    }

    this.updateRangeVisuals();
  }

  formatPrice(price) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " VND";
  }

  updateRangeVisuals() {
    const min = parseInt(this.minInput.value);
    const max = parseInt(this.maxInput.value);
    const percent1 =
      ((min - this.minInput.min) / (this.minInput.max - this.minInput.min)) *
      100;
    const percent2 =
      ((max - this.minInput.min) / (this.minInput.max - this.minInput.min)) *
      100;

    this.range.style.left = percent1 + "%";
    this.range.style.width = percent2 - percent1 + "%";

    this.minValue.textContent = this.formatPrice(min);
    this.maxValue.textContent = this.formatPrice(max);
  }

  updateFormAndSubmit() {
    const min = this.minInput.value;
    const max = this.maxInput.value;
    const minFormInput = this.form.querySelector(
      'input[name="filter.v.price.gte"]'
    );
    const maxFormInput = this.form.querySelector(
      'input[name="filter.v.price.lte"]'
    );

    const formatNumber = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    if (minFormInput) minFormInput.value = formatNumber(min);
    if (maxFormInput) maxFormInput.value = formatNumber(max);

    this.form.dispatchEvent(new Event("input", { bubbles: true }));

    // Load more products
    loadMoreProducts();
  }

  clearFilter() {
    const minDefault = this.minInput.min;
    const maxDefault = this.maxInput.max;

    this.minInput.value = minDefault;
    this.maxInput.value = maxDefault;

    this.minValue.textContent = this.formatPrice(minDefault);
    this.maxValue.textContent = this.formatPrice(maxDefault);

    this.updateRangeVisuals();
    this.updateFormAndSubmit();
  }

  init() {
    this.minInput.addEventListener("input", () => {
      if (parseInt(this.minInput.value) > parseInt(this.maxInput.value)) {
        this.minInput.value = this.maxInput.value;
      }
      this.updateRangeVisuals();
    });

    this.maxInput.addEventListener("input", () => {
      if (parseInt(this.maxInput.value) < parseInt(this.minInput.value)) {
        this.maxInput.value = this.minInput.value;
      }
      this.updateRangeVisuals();
    });

    this.minInput.addEventListener("change", () => this.updateFormAndSubmit());
    this.maxInput.addEventListener("change", () => this.updateFormAndSubmit());

    const clearButton = document.getElementById("clear-price-filter");
    if (clearButton) {
      clearButton.addEventListener("click", () => this.clearFilter());
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new PriceRangeSlider(
    "min-price",
    "max-price",
    "min-value",
    "max-value",
    "slider-range",
    "FacetFiltersFormMobile"
  );
});
